import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';
import {
  ApprovalRequestDetail,
  GetApprovalProgressResponse,
} from '../models/approval.model';
import { ApiResponse } from '../models/api-response.models';

/**
 * Approval Service
 * Handles all HTTP requests related to approval requests
 */
@Injectable({
  providedIn: 'root',
})
export class SharedApprovalService {
  private readonly baseUrl = `${environment.policyManagementApiUrl}/api/v1/approval-requests`;

  constructor(private http: HttpClient) {}

  /**
   * Get approval request progress
   * @param id Approval request ID
   * @returns Observable of approval progress response
   */
  getApprovalRequestProgress(
    id: string
  ): Observable<GetApprovalProgressResponse> {
    return this.http.get<GetApprovalProgressResponse>(
      `${this.baseUrl}/${id}/progress`
    );
  }
  getApprovalRequestById(
    id: string
  ): Observable<ApiResponse<ApprovalRequestDetail>> {
    return this.http.get<ApiResponse<ApprovalRequestDetail>>(
      `${this.baseUrl}/${id}`
    );
  }
}
